import { Dashboard } from '@src/pages/Dashboard';

export function DashboardContainer() {
    return <Dashboard />;
}
